export const styles = theme => ({
    root : {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        padding : '0px',
    }, 
    label: {
        display : 'block',
        textAlign: 'right',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    checkedBox: {
        float: 'right'
    },
    labelDay : {
        padding: '6px 0 7px',
        display : 'block',
        
    },
    icon : {
        fontSize : '20px',
        cursor : 'pointer',
    },
    myClock : {
        background: '#FF513F'
    },
    rootTitle: {
        marginBottom: theme.spacing(3)
    }
})